<div class="registration registration-container"
  fxLayout="column">
  <div fxFlex="grow"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="16px"
    class="registration-content">
    <mat-card class="mat-secondary border-full primary-border"
      fxLayout="row"
      fxLayoutAlign="center"
      ngClass.gt-xs="content"
      ngClass.lt-sm="mat-elevation-z0">
      <mat-card-content>
        @if (loaderShowing) {
          <div fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="8px"
            class="loading-screen">
            <mat-spinner color="primary"></mat-spinner>
            <h1>Validating email link</h1>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
